import OrdensDeServico from "@/pages/ordemServico/Listar";

export const ordensDeServicoRoutes = [
  {
    path: "/ordens-de-servico",
    name: "ordensDeServico",
    component: OrdensDeServico,
  }
];

export default {};
